<script setup lang="ts">
const props = withDefaults(defineProps<{
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark',
  dismissible?: boolean
}>(), {
  variant: 'primary',
  dismissible: false
})

const emit = defineEmits(['close'])
</script>

<template>
  <div :class="['show', 'alert', `alert-${props.variant}`, { 'alert-dismissible': props.dismissible }]" role="alert">
    <slot />
    <button v-if="props.dismissible" type="button"
            class="close" data-dismiss="alert"  aria-label="Close"
            @click="emit('close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>
